module.exports = "/images/vendor/flag-icon-css/flags/1x1/sg.svg?9eb47fe757c9d8abb85049a379b606a0";